export enum DropdownEventType {
  MouseClick = "MouseClick",
  MouseDoubleClick = "MouseDoubleClick",
  MouseEnter = "MouseEnter",
  MouseContext = "MouseContext",
  MouseAuxClick = "MouseAuxClick"
}
